import { render, staticRenderFns } from "./ViewCitizenModal.vue?vue&type=template&id=671b529f&scoped=true&"
import script from "./ViewCitizenModal.vue?vue&type=script&lang=js&"
export * from "./ViewCitizenModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewCitizenModal.vue?vue&type=style&index=0&id=671b529f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671b529f",
  null
  
)

export default component.exports